import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/organization-profile/"
)({
  component: () => (
    <Navigate
      to="/organization-settings/organization-profile/$tabKey"
      params={{ tabKey: "profile" }}
    />
  ),
})
